import Input from './input';

export default Input;



// WEBPACK FOOTER //
// ./src/components/elements/input/index.js